// @flow

import UserApi from "../../api/UserApi/UserApi";
import Team from "../../models/Team/Team";

class UserService {

    userApi: UserApi;

    constructor(userApi: UserApi) {
        this.userApi = userApi;
    }

    async getTeam() : Promise<Team>{
        const projectManagers = await this.userApi.getProjectMangers();
        const tenantAdmins = await this.userApi.getTenantAdmins();
        const projectAdmins = await this.userApi.getProjectAdmins();

        return new Team(projectManagers, tenantAdmins,projectAdmins)
    }

    async getUser(userId) {
        return await this.userApi.getUser(userId);
    }

    async getAllUsers() {
        return await this.userApi.getAllUsers();
    }

    async createUser(userInfo: Object) {
        return await this.userApi.createUser(userInfo);
    }

    async updateUser(userId, userInfo: Object) {
        return await this.userApi.updateUser(userId, userInfo);
    }

    async deleteUser(userId) {
        return await this.userApi.deleteUser(userId);
    }
}

export default UserService;
